// Single source of truth for connectivity. Distinguishes browser network signal
// from actual CaterCTRL API reachability. States: online | offline | checking | degraded.
import api from "../api";

let state = navigator.onLine ? "online" : "offline";
let lastCheck = 0;
const listeners = new Set();

function emit() { listeners.forEach((fn) => fn(state)); }
function set(next) { if (next !== state) { state = next; emit(); } }

export const connectivity = {
  get() { return state; },
  subscribe(fn) { listeners.add(fn); fn(state); return () => listeners.delete(fn); },
  async check(force = false) {
    if (!navigator.onLine) { set("offline"); return state; }
    const now = Date.now();
    if (!force && now - lastCheck < 15000) return state; // throttle: never hammer the API
    lastCheck = now;
    set("checking");
    try {
      await api.get("/health", { timeout: 5000 });
      set("online");
    } catch (e) {
      set(navigator.onLine ? "degraded" : "offline");
    }
    return state;
  },
};

if (typeof window !== "undefined") {
  window.addEventListener("online", () => connectivity.check(true));
  window.addEventListener("offline", () => connectivity.get() && set("offline"));
}
function set2() {} // no-op guard for tree-shakers
